{
  "$id": "wealthlane://forms/performance-rule",
  "$schema": "wealthlane://schemas/form-model",
  "domain": "../performance-rule.domain.json",
  "properties": {
    "id": {
      "$ref": "module://performance-rule#properties/id"
    },
    "ruleName": {
      "$ref": "module://performance-rule#properties/ruleName",
      "required": true
    },
    "ruleTypeId": {
      "$ref": "module://performance-rule#properties/ruleTypeId",
      "required": true,
      "actionId": "FETCH_PERFORMANCE_RULE_TYPE_OPTIONS",
      "dependsOn": []
    },
    "isAvailable": {
      "$ref": "module://performance-rule#properties/isAvailable",
      "required": true,
      "adapterProps": {
        "reserveLabelSpace": false
      }
    },
    "evaluationPeriodStartDate": {
      "$ref": "module://performance-rule#properties/evaluationPeriodStartDate",
      "required": true
    },
    "evaluationPeriodEndDate": {
      "$ref": "module://performance-rule#properties/evaluationPeriodEndDate",
      "required": true,
      "reactions": [
        {
          "watch": ["evaluationPeriodStartDate"],
          "set": "minDate",
          "compute": {
            "operator": "field",
            "name": "evaluationPeriodStartDate"
          }
        }
      ]
    },
    "minimumPercentage": {
      "$ref": "module://performance-rule#properties/minimumPercentage",
      "required": true
    },
    "maximumPercentage": {
      "$ref": "module://performance-rule#properties/maximumPercentage",
      "required": true
    },
    "ruleDescription": {
      "$ref": "module://performance-rule#properties/ruleDescription",
      "required": true
    },
    "ruleSummary": {
      "$ref": "module://performance-rule#properties/ruleSummary",
      "required": true
    },
    "showRuleDisplayToParticipant": {
      "$ref": "module://performance-rule#properties/showRuleDisplayToParticipant",
      "required": true,
      "adapterProps": {
        "reserveLabelSpace": false
      }
    },
    "showPerformanceTrackingToParticipant": {
      "$ref": "module://performance-rule#properties/showPerformanceTrackingToParticipant",
      "required": true,
      "adapterProps": {
        "reserveLabelSpace": false
      }
    },
    "estimatePerformanceTrackings": {
      "type": "array",
      "title": "Estimate Performance Tracking",
      "items": {
        "type": "object",
        "required": ["trackingDate", "multiplierPercentage"],
        "properties": {
          "trackingDate": {
            "$ref": "module://performance-rule#properties/trackingDate",
            "reactions": [
              {
                "watch": ["^evaluationPeriodStartDate"],
                "set": "minDate",
                "compute": { "operator": "field", "name": "^evaluationPeriodStartDate" }
              },
              {
                "watch": ["^evaluationPeriodEndDate"],
                "set": "maxDate",
                "compute": { "operator": "field", "name": "^evaluationPeriodEndDate" }
              }
            ]
          },
          "multiplierPercentage": {
            "$ref": "module://performance-rule#properties/multiplierPercentage"
          },
          "comment": {
            "$ref": "module://performance-rule#properties/comment"
          },
          "minValue": {
            "$ref": "module://performance-rule#properties/minValue"
          },
          "maxValue": {
            "$ref": "module://performance-rule#properties/maxValue"
          }
        }
      }
    },
    "performanceEvaluation": {
      "type": "object",
      "title": "Final Evaluation",
      "properties": {
        "performanceEvaluationId": {
          "$ref": "module://performance-rule#properties/performanceEvaluationId"
        },
        "evaluationDate": {
          "$ref": "module://performance-rule#properties/evaluationDate",
          "reactions": [
            {
              "watch": ["^evaluationPeriodStartDate"],
              "set": "minDate",
              "compute": {
                "operator": "field",
                "name": "^evaluationPeriodStartDate"
              }
            }
          ]
        },
        "earnedMultipier": {
          "$ref": "module://performance-rule#properties/earnedMultipier"
        },
        "minValue": {
          "$ref": "module://performance-rule#properties/minValue"
        },
        "maxValue": {
          "$ref": "module://performance-rule#properties/maxValue"
        }
      }
    }
  },
  "dataSource": {
    "submit": {
      "actionId": "SAVE_PERFORMANCE_RULE",
      "refreshEntities": ["Performance Rule"],
      "invalidateQueries": ["getPerformanceRulesList", "getAvailablePerformanceRules", "dt-v2-page"]
    }
  },
  "modes": {
    "create": {
      "dataSource": {
        "submit": {
          "successMessage": "Performance Rule Added"
        }
      },
      "lifecycle": {
        "submitBehavior": "close"
      }
    },
    "edit": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_PERFORMANCE_RULE_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        },
        "submit": {
          "successMessage": "Performance Rule Edited"
        }
      },
      "lifecycle": {
        "submitBehavior": "close"
      }
    },
    "view": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_PERFORMANCE_RULE_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        }
      },
      "viewPresentation": "disabled-inputs"
    }
  }
}
